export const baseUnits = [
	{ value: 1, label: "g - cc" },
	{ value: 1000, label: "Kg - L" },
	{ value: 10000, label: "Tn - KL" },
];

export const baseFilterOrders = {
	page: 1,
	paginate: 10,
	order: "dealer_number",
	orderType: "desc",
	defaultUnitFilter: 1000,
	purchaseOrderDeliveryFilter: "",
	dateFilter: "",
	dateToFilter: "",
};

export const table_head = [
	// {
	// 	name: "",
	// 	size: "5",
	// 	order: "",
	// },
	{
		name: "Código",
		size: "10",
		order: "code",
	},
	{
		name: "Fecha",
		size: "20",
		order: "created_at",
	},
	{
		name: "Distribuidor",
		size: "15",
		order: "created_at",
	},
	{
		name: "N° Factura",
		size: "15",
		order: "dealer_number",
	},
	{
		name: "delivery_text_numero",
		size: "15",
		order: "delivery_number",
	},
	{
		name: "Cant. de Productos",
		size: "15",
		order: "quantity_products",
	},
	{
		name: "Acción",
		size: "5",
		order: "",
	},
	{
		name: "",
		size: "5",
		order: "",
	},
];
